import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { loremIpsum } from "../../../utils/Actions/LoremIpsum";
import { getGenreFooterMedia } from "../../../utils/api/helpers/pages";
import FooterMediaItem from "./FooterMediaItem";

export default function FooterMedia({ activeGenre }) {
  const [footerEvents, setFooterEvents] = useState(null);
  const [footerPress, setFooterPress] = useState(null);
  const [footerVideos, setFooterVideos] = useState(null);

  const dedupeByTitle = (items = []) => {
    const seenTitles = new Set();

    return items.filter((item) => {
      if (!item?.title) return true; // keep items without titles
      if (seenTitles.has(item.title)) return false;

      seenTitles.add(item.title);
      return true;
    });
  };

  useEffect(() => {
    const slug = activeGenre?.slug;
    if (!slug) return;

    let cancelled = false;

    // clear immediately so UI can’t show previous genre’s items
    setFooterEvents([]);
    setFooterPress([]);
    setFooterVideos([]);

    getGenreFooterMedia(slug).then((res) => {
      if (cancelled) return;

      setFooterEvents(res.data.events?.[0] ?? []);
      setFooterPress(res.data.press?.[0] ?? []);
      setFooterVideos(dedupeByTitle(res.data.video?.[0] ?? []));
    });

    return () => {
      cancelled = true;
    };
  }, [activeGenre?.slug]);

  return (
    <div className={"page-sink-right"}>
      {footerEvents?.length || footerPress?.length || footerVideos?.length ? (
        <h3 className={"page-sink-title"}>Explore {activeGenre?.title}</h3>
      ) : (
        <></>
      )}
      <div className={"page-sink-columns flex-column flex-md-row"}>
        {footerEvents?.length > 0 && (
          <div className={"page-sink-column"}>
            <h3 className={"page-sink-column-title"}>Events</h3>
            {footerEvents.map((item, index) => (
              <FooterMediaItem
                key={item?.slug ?? item?.url ?? item?.filename}
                item={item}
                type={"events"}
                activeGenre={activeGenre}
              />
            ))}
          </div>
        )}
        {footerPress?.length > 0 && (
          <div className={"page-sink-column"}>
            <h3 className={"page-sink-column-title"}>Press</h3>
            {footerPress.map((item, index) => (
              <FooterMediaItem
                key={item?.slug ?? item?.url ?? item?.filename}
                item={item}
                type={"press"}
                activeGenre={activeGenre}
              />
            ))}
          </div>
        )}
        {footerVideos?.length > 0 && (
          <div className={"page-sink-column"}>
            <h3 className={"page-sink-column-title"}>Videos</h3>
            {footerVideos.map((item, index) => (
              <FooterMediaItem
                key={item?.slug ?? item?.url ?? item?.filename}
                item={item}
                type={"video"}
                activeGenre={activeGenre}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
